import * as React from "react"
import "normalize.css"
import { Helmet } from "react-helmet"
import Mobile from "../components/Mobile"

const IndexPage = () => {
  return (
    <>
      <Helmet>
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://abdalla-hossainy.netlify.app/" />
        <meta property="og:title" content="Abdalla Al-Hossainy" />
        <meta
          property="og:description"
          content="Hi, My name is Abdalla, I am Web Designer and Developer check my portfolio for more information."
        />
        <meta
          property="og:image"
          content="https://lh3.googleusercontent.com/pw/ACtC-3eZYy6QOfgYhji-HBh3Lhn-aTIYBRIHZCNg1reGypisd3n3FSbaohdMtpUxXU6RauSZL_D8-GW_WGYOfcA_uizrayzgRG3je2flYDBg50EJgFqg7FMu7pa3I51zlEopg5z4_4OUiDWCgchYrFWAV44N=w1200-h628-no"
        />

        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://abdalla-hossainy.netlify.app/" />
        <meta property="twitter:title" content="Abdalla Al-Hossainy" />
        <meta
          property="twitter:description"
          content="Hi, My name is Abdalla, I am Web Designer and Developer check my portfolio for more information."
        />
        <meta
          property="twitter:image"
          content="https://lh3.googleusercontent.com/pw/ACtC-3eZYy6QOfgYhji-HBh3Lhn-aTIYBRIHZCNg1reGypisd3n3FSbaohdMtpUxXU6RauSZL_D8-GW_WGYOfcA_uizrayzgRG3je2flYDBg50EJgFqg7FMu7pa3I51zlEopg5z4_4OUiDWCgchYrFWAV44N=w1200-h628-no"
        />

        <meta name="title" content="Abdalla Al-hossainy" />
        <meta
          name="description"
          content="Hi, My name is Abdalla, I am Web Designer and Developer check my portfolio for more information."
        />
        <meta
          name="keywords"
          content="web-designer,web-developer,web-animator,motion-graphic-designer, clean-website,portfolio-website,portfolio-design,ux\ui-designer"
        />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="author" content="Abdalla Al-Hossainy" />
        <meta
          name="viewport"
          content="width = device-width,initial-scale = 1.0, user-scalable = no, maximum-scale=1.0,"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="#000" />
        <title>Abdalla Al-Hossainy</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-sacle=1, maximum-scale=1, user-scalable=no"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <script
          src="https://cdnjs.cloudflare.com/ajax/libs/mobile-detect/1.4.5/mobile-detect.min.js"
          type="text/javascript"
        />
        <script>{`
             var userAgent = window.navigator.userAgent
            var md = new MobileDetect(userAgent)
            isMobile = md.mobile() != null
            console.log(isMobile)
            if (!isMobile) {
            window.location.replace("./home")
            }
        `}</script>
      </Helmet>

      <Mobile />
    </>
  )
}

export default IndexPage
